<template>
  <b-container fluid class="px-0">
    <div class="position-relative content-div">
      <AcademyTopOffer :customerInfo="customerInfo"/>
      <AcademyCategoriesCards 
        v-on:navigate="navigate($event)" 
        :customerInfo="customerInfo"/>
      <component
          :is="contentComponent"
          @updated="contentUpdated"
          :customerInfo="customerInfo"
          :academyCardsData="academyCardsData"
          :step="step"
      />
    </div>
  </b-container>
</template>

<script>
import AcademyTopOffer from "@/components/centre/academy/AcademyTopOffer.vue";
import AcademyCategoriesCards from "@/components/centre/academy/AcademyCategoriesCards.vue";
import AcademyShowAllCards from "@/components/centre/academy/AcademyShowAllCards.vue";

import Step1Img from "@/assets/images/centre/academy/academy-cards/Step1.png";
import Step2Img from "@/assets/images/centre/academy/academy-cards/Step2.png";
import Step3Img from "@/assets/images/centre/academy/academy-cards/Step3.png";
import Step4Img from "@/assets/images/centre/academy/academy-cards/Step4.png";
import Step5Img from "@/assets/images/centre/academy/academy-cards/Step5.png";
import Step6Img from "@/assets/images/centre/academy/academy-cards/Step6.png";
import Step7Img from "@/assets/images/centre/academy/academy-cards/Step7.png";
import Step8Img from "@/assets/images/centre/academy/academy-cards/Step8.png";
import Step9Img from "@/assets/images/centre/academy/academy-cards/Step9.png";
import Step10Img from "@/assets/images/centre/academy/academy-cards/Step10.png";
import Step11Img from "@/assets/images/centre/academy/academy-cards/Step11.png";
import Step12Img from "@/assets/images/centre/academy/academy-cards/Step12.png";
import Step13Img from "@/assets/images/centre/academy/academy-cards/Step13.png";
import Step14Img from "@/assets/images/centre/academy/academy-cards/Step14.png";
import Step15Img from "@/assets/images/centre/academy/academy-cards/Step15.png";
import Step16Img from "@/assets/images/centre/academy/academy-cards/Step16.png";
import Step17Img from "@/assets/images/centre/academy/academy-cards/Step17.png";
import DropsmartsSecretsImg from "@/assets/images/centre/academy/academy-cards/DropsmartsSecrets.png";
import StayingOrganizedImg from "@/assets/images/centre/academy/academy-cards/pro-tips/Staying-organized-&-keeping-track-of-your-recipes-with-Dropsmart.png";
import SqueezingImg from "@/assets/images/centre/academy/academy-cards/pro-tips/Squeezing-out-the-benefits-of-GC-reports.png";
import HowToGetImg from "@/assets/images/centre/academy/academy-cards/pro-tips/How-to-get-the-most-out-of-referencing-with-Dropsmart.png";
import HowToFindImg from "@/assets/images/centre/academy/academy-cards/pro-tips/How-to-find-the-perfect-essential-oil-within-seconds.png";
import RainbowImg from "@/assets/images/centre/academy/academy-cards/pro-tips/Revealing-the-rainbow-of-aromas.png";
import SaveTimeImg from "@/assets/images/centre/academy/academy-cards/pro-tips/Save-time-with-Dashboard.png";
import UnleashImg from "@/assets/images/centre/academy/academy-cards/pro-tips/Unleash-your-inner-genius-with-Smart-Blending.png";

export default {
  title: "Center Academy",
  name: "Academy",
  props: ["page", "customerInfo", "step"],
  components: {
    AcademyTopOffer,
    AcademyCategoriesCards,
    AcademyShowAllCards,
  },
  mounted() {
    let target = this.page ? this.page : "AcademyShowAllCards";
    console.log("navigating to " + target);
    this.navigate(target);
  },
  data() {
    return {
      content: null,
      // categories possible by now: ProTips / MasterApp / Extra
      academyAllCardsData: [
        {
          id: 1,
          category: "MasterApp",
          productTitle: "Step #1",
          description: "Why one essential oil works",
          modalDescription: "Why one essential oil works",
          cardImage: Step1Img,
          videoUrl: "https://player.vimeo.com/video/777341015", 
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 2,
          category: "MasterApp",
          productTitle: "Step #2",
          description: "How essential oils are the same and different at the same time",
          modalDescription: "How essential oils are the same and different at the same time",
          cardImage: Step2Img,
          videoUrl: "https://player.vimeo.com/video/885338340",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 3,
          category: "MasterApp",
          productTitle: "Step #3",
          description: "Why Chemistry is your friend",
          modalDescription: "Why Chemistry is your friend",
          cardImage: Step3Img,
          videoUrl: "https://player.vimeo.com/video/777339854",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 4,
          category: "MasterApp",
          productTitle: "Step #4",
          description: "Finding an appropriate substitute (for any essential oil)",
          modalDescription: "Finding an appropriate substitute (for any essential oil)",
          cardImage: Step4Img,
          videoUrl: "https://player.vimeo.com/video/777340307",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 5,
          category: "MasterApp",
          productTitle: "Step #5",
          description: "How to use the Search Button",
          modalDescription: "How to use the Search Button",
          cardImage: Step5Img,
          videoUrl: "https://player.vimeo.com/video/773461199",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 6,
          category: "MasterApp",
          productTitle: "Step #6",
          description: "Safe usage of the unknown oils",
          modalDescription: "Safe usage of the unknown oils",
          cardImage: Step6Img,
          videoUrl: "https://player.vimeo.com/video/773445638",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 7,
          category: "MasterApp",
          productTitle: "Step #7",
          description: "Less oils = More control",
          modalDescription: "Less oils = More control",
          cardImage: Step7Img,
          videoUrl: "https://player.vimeo.com/video/773461645",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 8,
          category: "MasterApp",
          productTitle: "Step #8",
          description: "Cutting out Guesswork",
          modalDescription: "Cutting out Guesswork",
          cardImage: Step8Img,
          videoUrl: "https://player.vimeo.com/video/773470076",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 9,
          category: "MasterApp",
          productTitle: "Step #9",
          description: "Recognizing smell through color",
          modalDescription: "Recognizing smell through color",
          cardImage: Step9Img,
          videoUrl: "https://player.vimeo.com/video/773471615",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 10,
          category: "MasterApp",
          productTitle: "Step #10",
          description: "Picking your top 5 oils",
          modalDescription: "Picking your top 5 oils",
          cardImage: Step10Img,
          videoUrl: "https://player.vimeo.com/video/773470706",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 11,
          category: "MasterApp",
          productTitle: "Step #11",
          description: "Conscious usage of the essential oils",
          modalDescription: "Conscious usage of the essential oils",
          cardImage: Step11Img,
          videoUrl: "https://player.vimeo.com/video/774841919",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 12,
          category: "MasterApp",
          productTitle: "Step #12",
          description: "Debunking Universal Diluting Percentage Myth",
          modalDescription: "Debunking Universal Diluting Percentage Myth",
          cardImage: Step12Img,
          videoUrl: "https://player.vimeo.com/video/774842732",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 13,
          category: "MasterApp",
          productTitle: "Step #13",
          description: "Learning how to ask the right question",
          modalDescription: "Learning how to ask the right question",
          cardImage: Step13Img,
          videoUrl: "https://player.vimeo.com/video/774843437",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 14,
          category: "MasterApp",
          productTitle: "Step #14",
          description: "Self-expression through Aromatherapy",
          modalDescription: "Self-expression through Aromatherapy",
          cardImage: Step14Img,
          videoUrl: "https://player.vimeo.com/video/774843908",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 15,
          category: "MasterApp",
          productTitle: "Step #15",
          description: "Experimentation without the consequences",
          modalDescription: "Experimentation without the consequences",
          cardImage: Step15Img,
          videoUrl: "https://player.vimeo.com/video/774844539",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 16,
          category: "MasterApp",
          productTitle: "Step #16",
          description: "Conquering Impostor Syndrome",
          modalDescription: "Conquering Impostor Syndrome",
          cardImage: Step16Img,
          videoUrl: "https://player.vimeo.com/video/774845083",
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 17,
          category: "MasterApp",
          productTitle: "Step #17",
          description: "Achieving ultimate literature independency",
          modalDescription: "Achieving ultimate literature independency",
          cardImage: Step17Img,
          videoUrl: "https://player.vimeo.com/video/774845821", 
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 18,
          category: "Extra",
          productTitle: "Dropsmart's start",
          description: "",
          modalDescription: "Exclusive video from THE BEYOND THE ESSENTIAL OIL RECIPE SUMMIT",
          cardImage: DropsmartsSecretsImg,
          videoUrl: "https://www.youtube.com/embed/xcST4Tdqu9Y?rel=0", 
          showLeftButton: false,
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "modalSubtitle",
        },
        {
          id: 19,
          category: "ProTips",
          productTitle: "How to get the most out of referencing with Dropsmart?",
          description: "",
          modalDescription: "",
          cardImage: HowToFindImg,
          // videoUrl: "https://youtu.be/71qFFvH5JgU",
          videoUrl: "https://www.youtube.com/embed/71qFFvH5JgU?rel=0", 
          showLeftButton: false,
          showOnDeck: false,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 20,
          category: "ProTips",
          productTitle: "How to find the perfect essential oil within seconds?",
          description: "",
          modalDescription: "",
          cardImage: HowToGetImg, 
          // videoUrl: "https://youtu.be/q_QysxX21rU",  
          videoUrl: "https://www.youtube.com/embed/q_QysxX21rU?rel=0", 
          showLeftButton: false,
          showOnDeck: false,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 21,
          category: "ProTips",
          productTitle: "Staying organized & keeping track of your recipes with Dropsmart ",
          description: "",
          modalDescription: "",
          cardImage: SqueezingImg,
          // videoUrl: "https://youtu.be/eepSMlHVhZc", 
          videoUrl: "https://www.youtube.com/embed/eepSMlHVhZc?rel=0", 
          showLeftButton: false, 
          showOnDeck: false,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 22,
          category: "ProTips",
          productTitle: "Squeezing out the benefits of GC reports",
          description: "",
          modalDescription: "",
          cardImage: StayingOrganizedImg,
          // videoUrl: "https://youtu.be/UwVZn0_dxpw",
          videoUrl: "https://www.youtube.com/embed/UwVZn0_dxpw?rel=0",
          showLeftButton: false, 
          showOnDeck: false,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 23,
          category: "ProTips",
          productTitle: "Save time with Dashboard: Unlock Your Efficiency!",
          description: "",
          modalDescription: "",
          cardImage: SaveTimeImg,
          videoUrl: "https://player.vimeo.com/video/788656393", 
          showLeftButton: false, 
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 24,
          category: "ProTips",
          productTitle: "Unleash your inner genius with Smart Blending",
          description: "",
          modalDescription: "",
          cardImage: UnleashImg,
          videoUrl: "https://player.vimeo.com/video/788656908", 
          showLeftButton: false, 
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
        {
          id: 25,
          category: "ProTips",
          productTitle: "Revealing the rainbow of aromas",
          description: "",
          modalDescription: "",
          cardImage: RainbowImg,
          videoUrl: "https://player.vimeo.com/video/788657408", 
          showLeftButton: false, 
          showOnDeck: true,
          hasModal: true,
          modalSubtitle: "Your success with Dropsmart is important to us, it is also important to others.",
        },
      ],
    };
  },
  computed: {
    contentComponent() {
      return this.content;
    },
    academyCardsData() {
      return this.academyAllCardsData.filter(function(u) {
        return u.showOnDeck;
      });
    },
  },
  methods: {
    navigate(routeName) {
      this.content = routeName;
    },
    contentUpdated() {
      this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
    },
  },
};
</script>

<style scoped lang="scss">

</style>